import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_DOCUMENT } from "../../constants/modules"

import { documentQueryKeys } from "./queryKeys"
import { useDocumentQuery } from "./useDocumentQuery"

export function useDocument(documentId, params = {}) {
    const url = `documents/${documentId}/`
    const queryParameters = useExtendWithSubnetworks(params, API_MODULE_DOCUMENT)
    const queryKey = documentQueryKeys.detail(documentId, queryParameters)

    return useDocumentQuery(
        url,
        queryKey,
        queryParameters,
        {
            autoRefetch: true,
        },
    )
}

export function useDocuments(params = {}) {
    const url = "documents/"
    const queryParameters = useExtendWithSubnetworks(params, API_MODULE_DOCUMENT)
    const queryKey = documentQueryKeys.list(queryParameters)

    return useDocumentQuery(
        url,
        queryKey,
        queryParameters,
        {
            autoRefetch: true,
        },
    )
}